import React from "react";
import HoneyAsset from "../../images/gbrHome/machinery.webp";
import FinancialSupport from "../../images/coin-wooden-table.jpg";
import ProcessingSupport from "../../images/processingService/banner.jpg";
import { NavLink } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

export default function MoneyMakingAssets() {
  const services = [
    // {
    //   title: "Community",
    //   image: Community,
    //   href: "/Community",
    // },
    {
      title: "Income-generating Service",
      image: HoneyAsset,
      href: "/income-generating-Services",
      customPropValue: "processing",
    },
    {
      title: "Financial Service",
      image: FinancialSupport,
      href: "/financial-services",
      // customPropValue: "processing",

    },
    {
      title: "Business Growth Service",
      image: ProcessingSupport,
      href: "/GrowthService",
      customPropValue: "PM",
    },
  ];

  return (
    <div className="container for-farmer-section2 subSectionWrapper px-0">
      <h2 className="text-center title mb-4 mb-lg-5 container-title">
        Our Services
      </h2>
      <Row className="justify-content-center">
        {services.map((e,i) => (
          <Col md={4} key={i} >
            <NavLink
              to={{ pathname: e.href, state: { customProp: e.customPropValue } }}
            >
              <div className="image-container mb-4">
                <img className="" src={e.image} alt="Investment asset" />
              </div>
              <h3 className="text-center container-heading1 mt-0 mb-md-0 mb-4 text-decoration-none">
                {e.title}
              </h3>
            </NavLink>
          </Col>
        ))}
      </Row>
    </div>
  );
}
